import * as React from "react";
import { singleton } from "logic/singleton";
const AutoRefreshContext = React.createContext(null);
export default singleton("contexts.AutoRefreshContext", () => AutoRefreshContext);
